import { type FC } from "react";

import { faFileDownload } from "@fortawesome/pro-duotone-svg-icons/faFileDownload";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { type DocumentFragment } from "@app_schema";

import { track } from "@application/utilities/track";

import { ButtonAnchor } from "@styled/button_anchor";

export const DocumentDownloadButton: FC<{
  document: DocumentFragment;
}> = ({ document }) => (
  <ButtonAnchor
    href={document.file.url}
    download
    onClick={() =>
      track("document_downloaded", {
        document_id: document.id,
        kind: document.kind ?? "document",
      })
    }
  >
    <FontAwesomeIcon icon={faFileDownload} />
    Download
  </ButtonAnchor>
);
